module.exports = __webpack_public_path__ + "img/errorNew.c0b86bba.png";